import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import marketplaceReducer from "./root-reducer";

const configureStore = () => {
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  return createStore(
    marketplaceReducer,
    composeEnhancers(applyMiddleware(thunk))
  );
};

const store = configureStore();
export default store;
